
import { FetchHelper } from "../utils/fetchHelper"

export const handleLogoutUser = async () => {
    try {
        const resData = await FetchHelper.post(
            "api/v1/user/logout", // url
            null, // data (body)
            null, // params
            {
                "Auth-Token": localStorage.getItem("token"),
            }, // headers (override)
        )
        if (resData?.data?.status) {
            localStorage.clear()
            sessionStorage.clear()
            window.location.href = "/"
        }
        return resData
    } catch (error) {
        console.warn(error, "Error")
        return error
    }
}
